import { render, staticRenderFns } from "./le-company-investors-select.vue?vue&type=template&id=b266da88&"
import script from "./le-company-investors-select.vue?vue&type=script&lang=js&"
export * from "./le-company-investors-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports